import api from 'api';
import useResource from './useResource';

const useBenchmarkSubmissions = () => {
	const {
		isEmpty,
		isLoading,
		findMany: findBenchmarkSubmissions,
		findOne: findBenchmarkSubmission,
		resource: benchmarkSubmission,
		resources: benchmarkSubmissions,
		handleErrors
	} = useResource({
		url: `/api/v1/admin/benchmark_submissions`,
		name: 'benchmark_submission',
		label: 'Benchmark Submission'
	});

	const submitBenchmarkFeedback = async (id, feedback) =>
		api.post(`/api/v1/admin/benchmark_submissions/${id}/feedback`, {
			feedback
		});

	return {
		isEmpty,
		isLoading,
		findBenchmarkSubmission,
		findBenchmarkSubmissions,
		benchmarkSubmission,
		benchmarkSubmissions,
		submitBenchmarkFeedback
	};
};

export default useBenchmarkSubmissions;
